import React from 'react'
import AboutHeroSection from '../../sections/AboutHeroSection/AboutHeroSection'
import StorySection from '../../sections/StorySection/StorySection'
import CrewSection from '../../sections/CrewSection/CrewSection'
import ReservationSection from '../../sections/ReservationSection/ReservationSection'
import FounderSection from '../../sections/FounderSection/FounderSection'
import ArticlesSection from '../../sections/ArticlesSection/ArticlesSection'

const AboutPage = () => {
  return (
    <div>
      <AboutHeroSection/>
      <FounderSection/>
      <ArticlesSection/>
      <StorySection/>
      <CrewSection/>
      <ReservationSection/>
    </div>
  )
}

export default AboutPage